<template>
    <div class="id-section">
        <div class="bg-title" :style="{ height: currentHeight + 'px' }">
            <div class="content">
                <div class="title" v-if="currentTitle">
                    <h2>{{ currentTitle }}</h2>
                </div>

                <div class="info" v-if="currentInfo">
                    <span v-html="currentInfo"></span>
                </div>

                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IdSection',
    props: {
        height: {
            type: Number,
            default: 306
        },
        title: {
            default: ''
        },
        info: {
            default: ''
        }
    },
    data() {
        return {
            currentHeight: null,
            currentTitle: null,
            currentInfo: null
        }
    },
    mounted() {
        this.currentHeight = this.height
        this.currentTitle = this.title
        this.currentInfo = this.info
    }
}
</script>

<style scope src="./IdSection-light-theme.css"></style>
<style scope src="./IdSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/id-section/IdSection.vue